// ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const LIMIT_CONSTRAINT = {
  queryTimeout: [
    'PERFORMANCE_QUERY_TIMEOUT_REQUIRED',
    'PERFORMANCE_QUERY_TIMEOUT_NUMBERICALITY',
    'PERFORMANCE_QUERY_TIMEOUT_GREATER_THAN_0',
    'PERFORMANCE_QUERY_TIMEOUT_LESS_THAN_MAX_INT'
  ],
  dataSourceLimit: [
    'PERFORMANCE_DS_LIMIT_REQUIRED',
    'PERFORMANCE_DS_LIMIT_NUMBERICALITY',
    'PERFORMANCE_DS_LIMIT_GREATER_THAN_0',
    'PERFORMANCE_DS_LIMIT_LESS_THAN_MAX_INT'
  ],
  fieldLimit: [
    'PERFORMANCE_FIELD_LIMIT_REQUIRED',
    'PERFORMANCE_FIELD_LIMIT_NUMBERICALITY',
    'PERFORMANCE_FIELD_LIMIT_GREATER_THAN_0',
    'PERFORMANCE_FIELD_LIMIT_LESS_THAN_MAX_INT'
  ],
  queryLimit: [
    'PERFORMANCE_QUERY_LIMIT_REQUIRED',
    'PERFORMANCE_QUERY_LIMIT_NUMBERICALITY',
    'PERFORMANCE_QUERY_LIMIT_GREATER_THAN_0',
    'PERFORMANCE_QUERY_LIMIT_LESS_THAN_MAX_INT'
  ],
  pivotColumnLimit: [
    'PERFORMANCE_PIVOT_COLUMN_LIMIT_REQUIRED',
    'PERFORMANCE_PIVOT_COLUMN_LIMIT_NUMBERICALITY',
    'PERFORMANCE_PIVOT_COLUMN_LIMIT_GREATER_THAN_0',
    'PERFORMANCE_PIVOT_COLUMN_LIMIT_LESS_THAN_MAX_INT'
  ],
  filterLimit: [
    'PERFORMANCE_FILTER_LIMIT_REQUIRED',
    'PERFORMANCE_FILTER_LIMIT_NUMBERICALITY',
    'PERFORMANCE_FILTER_LIMIT_GREATER_THAN_0',
    'PERFORMANCE_FILTER_LIMIT_LESS_THAN_MAX_INT'
  ]
};

export default {
  MAX_INT: Math.pow(2, 31),
  FIELD_NAMES: {
    QUERY_TIME_OUT: 'queryTimeout',
    DATA_SOURCE_LIMIT: 'dataSourceLimit',
    FIELD_LIMIT: 'fieldLimit',
    QUERY_LIMIT: 'queryLimit',
    PIVOT_COLUMN_LIMIT: 'pivotColumnLimit',
    FILTER_LIMIT: 'filterLimit'
  },

  getLimitConstraint(key) {
    return {
      presence: {
        presence: true,
        get message() {
          return localizer.getText(LIMIT_CONSTRAINT[key][0]);
        }
      },
      numericality: {
        onlyInteger: true,
        get notOnlyInteger() {
          return localizer.getText(LIMIT_CONSTRAINT[key][1]);
        },
        greaterThanOrEqualTo: 0,
        get notGreaterThanOrEqualTo() {
          return localizer.getText(LIMIT_CONSTRAINT[key][2]);
        },
        lessThanOrEqualTo: Math.pow(2, 31) - 1,
        get notLessThanOrEqualTo() {
          return localizer.getText(LIMIT_CONSTRAINT[key][3]);
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.PerformanceConstants.js